import base from './base'

export default {
	...base,
	title: {
		type: ['undefined', 'string']
	},
	expires_at: {
		type: ['undefined', 'string']
	},
	code: {
		type: ['undefined', 'string']
	},
	ref_id: {
		type: ['undefined', 'string']
	},
	ref_type: {
		type: ['undefined', 'string']
	},
	count: {
		type: ['number'],
		default: () => 0,
	},
	remain: {
		type: ['number'],
		default: () => 0,
	},
	discount: {
		type: ['number'],
		default: () => 0,
	},
	min_cart_amount: {
		type: ['number'],
		default: () => 0,
	},
	max_discount_amount: {
		type: ['number'],
		default: () => 0,
	},
	first_order: {
		type: ['boolean'],
		default: () => false,
	},
}
